.header {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 35px;
}
